import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface InvoiceDetailButtonProps {
  label: string;
  icon: React.ReactNode;
  color: string;
  value: string;
  textColor?: string;
  options?: Array<{id: string, name: string, child?: React.ReactNode}>;
  useSearch?: boolean;
  onClick?: () => void;
  onSelect: (id: string) => void;
  isDropdown?: boolean;
  children?: React.ReactNode;
}

export const InvoiceDetailButton: React.FC<InvoiceDetailButtonProps> = ({
  icon,
  label,
  color,
  value,
  textColor ='text-white',
  options,
  useSearch = false,
  onClick,
  onSelect,
  isDropdown = false,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    setFilteredOptions(options?.filter((option) => option.name.toLowerCase().includes(query.toLowerCase())));
  };

  const handleSelect = (id: string) => {
    onSelect(id);
    setIsOpen(false);
  };

  return (
    <div className='relative col-span-2'>
      <div
        onClick={() => {setIsOpen(!isOpen); onClick && onClick();}}
        className={`col-span-1 ${color} h-full cursor-pointer relative`}
      >
        <div className={`flex ${textColor} text-xs font-normal items-center gap-1 justify-between`}>
          <div className='flex items-center'>
            {icon}
            {label}
          </div>
          {isDropdown && <ChevronDown className={`h-5 w-5 ${textColor} pr-2`} />}
        </div>
        <div className={`text-lg ${textColor} px-1 font-bold`}>
          {value}
        </div>
        <div className='flex flex-row gap-1 items-baseline pt-1 p-1'>
          {children}
        </div>
      </div>
      {isOpen && (
        <div className='absolute z-10 mt-1 p-1 w-fit min-w-30 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 overflow-auto max-h-60'>
          {useSearch && (
            <div className='cursor-pointer p-1 w-full border-b border-gray-201'>
              <input
                type="text"
                placeholder="Search companies"
                className="w-full text-sm h-6 text-gray-500 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-transparent"
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          )}
          {filteredOptions?.map((option) => (
            <div
              className='cursor-pointer hover:bg-gray-100 p-1 w-full text-right'
              key={option.id}
              onClick={() => handleSelect(option.id)}
            >
              {option.child || option.name.replaceAll('_', ' ')}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InvoiceDetailButton;
